<template>
    <div class="home d-flex">
        <v-card class="d-flex flex-grow-1">
            <v-container fluid class="d-flex flex-grow-1">
                <v-row dense class="d-flex flex-grow-1" style="width: 100%">
                    <v-col cols="12">
                        <v-card
                            outlined
                            class="d-flex flex-column"
                            style="height: 100%"
                            id="accountTable"
                        >
                            <v-card-title
                                style="border-bottom: 1px solid #404040"
                                class="pt-2 pb-2"
                            >
                                <div class="text-left v-card-custom-title-left">
                                    Account Info
                                </div>
                                <div
                                    class="text-right v-card-custom-title-right"
                                >
                                    <div
                                        style="display: inline-table"
                                        id="accountFunctions"
                                    >
                                        <v-btn
                                            small
                                            color="default"
                                            :loading="accountLoading"
                                            @click="refreshAccount"
                                            ><v-icon>mdi-refresh</v-icon></v-btn
                                        >
                                    </div>
                                </div>
                            </v-card-title>

                            <v-data-table
                                class="flex-grow-1 custom-table"
                                dense
                                :headers="accountMobileHeader"
                                :items="filteredAccountData"
                                :loading="accountLoading"
                                loading-text="Loading... Please wait"
                                :items-per-page="-1"
                                :height="350"
                                :hide-default-footer="true"
                                fixed-header
                                :header-props="{ sortIcon: null }"
                                :mobile-breakpoint="0"
                            >
                                <template v-slot:item="{ item }">
                                    <tr>
                                        <td
                                            column="lp"
                                            style="
                                                text-wrap: nowrap;
                                                max-width: 140px;
                                                white-space: nowrap;
                                                overflow: hidden;
                                                text-overflow: ellipsis;
                                            "
                                        >
                                            <v-tooltip bottom>
                                                <template
                                                    v-slot:activator="{
                                                        on,
                                                        attrs,
                                                    }"
                                                >
                                                    <v-icon
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        style="
                                                            color: red;
                                                            margin-right: 5px;
                                                        "
                                                        size="15"
                                                        v-if="isWorkingDay"
                                                        v-show="
                                                            isOutsideOfTimeOffset(
                                                                item.updated_at
                                                            )
                                                        "
                                                    >
                                                        mdi-alert
                                                    </v-icon>
                                                </template>
                                                <span
                                                    >LP account info not up to
                                                    date, last update at:
                                                    {{ item.updated_at }}</span
                                                >
                                            </v-tooltip>
                                            {{ item.LP.toUpperCase() }}
                                        </td>
                                        <td column="Margin%" align="right">
                                            <div
                                                :style="
                                                    'color:' +
                                                    (item[
                                                        'Margin Utilization %'
                                                    ] > 50
                                                        ? 'red'
                                                        : 'white')
                                                "
                                            >
                                                {{
                                                    item[
                                                        "Margin Utilization %"
                                                    ].toFixed(2) + "%"
                                                }}
                                            </div>
                                        </td>
                                        <td column="Equity" align="right">
                                            {{
                                                numberWithCommas(
                                                    item.Equity.toFixed(2)
                                                )
                                            }}
                                        </td>
                                        <td
                                            column="Detail"
                                            class="fixCol_last"
                                            align="right"
                                            style="
                                                padding: 0 4px 0 0 !important;
                                            "
                                        >
                                            <v-icon
                                                small
                                                style="color: #2196f3"
                                                @click="
                                                    dialogShow = true;
                                                    dialogType = 'account';
                                                    dialogItem = item;
                                                "
                                                >mdi-eye</v-icon
                                            >
                                        </td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                    <v-col cols="12">
                        <v-card
                            class="d-flex flex-column"
                            style="height: 100%"
                            outlined
                            id="positionTable"
                        >
                            <v-card-title
                                style="border-bottom: 1px solid #404040"
                                class="pt-2 pb-2"
                            >
                                <div class="text-left v-card-title-left">
                                    Current Position
                                </div>
                                <div class="text-right v-card-title-right">
                                    <v-menu offset-y dense>
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-btn
                                                class="mr-2 ml-2"
                                                small
                                                color="primary"
                                                dark
                                                v-bind="attrs"
                                                v-on="on"
                                                id="lpChange"
                                            >
                                                <span
                                                    style="
                                                        display: block;
                                                        max-width: 150px;
                                                        white-space: nowrap;
                                                        overflow: hidden;
                                                        text-overflow: ellipsis;
                                                        font-size: 11px;
                                                    "
                                                    >{{ selectedLp }}</span
                                                >
                                            </v-btn>
                                        </template>
                                        <v-list dense>
                                            <v-list-item
                                                v-for="(item, index) in lpList"
                                                :key="item.id"
                                                v-on:click="changeLp(item)"
                                            >
                                                <v-list-item-title>{{
                                                    item.lp_name.toUpperCase()
                                                }}</v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>

                                    <v-btn
                                        small
                                        color="default"
                                        :loading="positionLoading"
                                        @click="refreshPosition"
                                        id="lpRefresh"
                                        ><v-icon>mdi-refresh</v-icon></v-btn
                                    >
                                </div>
                            </v-card-title>

                            <v-data-table
                                v-model="selectedSymbols"
                                class="flex-grow-1 custom-table"
                                dense
                                :headers="positionMobileHeader"
                                :items="lpPositionData"
                                item-key="id"
                                :loading="positionLoading"
                                loading-text="Loading... Please wait"
                                :items-per-page="-1"
                                :hide-default-footer="true"
                                fixed-header
                                :height="400"
                                :header-props="{ sortIcon: null }"
                                :mobile-breakpoint="0"
                            >
                                <template v-slot:header.Symbol="{ header }">
                                    {{ header.text }}
                                    <v-menu
                                        offset-y
                                        :close-on-content-click="false"
                                        top
                                    >
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-icon
                                                small
                                                v-bind="attrs"
                                                v-on="on"
                                                @click.prevent="
                                                    onSearch('symbolSearch')
                                                "
                                            >
                                                mdi-magnify
                                            </v-icon>
                                        </template>
                                        <div
                                            style="
                                                background-color: #1e1e1e;
                                                width: 280px;
                                            "
                                        >
                                            <v-text-field
                                                v-model="search"
                                                class="px-4"
                                                type="text"
                                                ref="symbolSearch"
                                                label="Enter the search term"
                                                style="width: 100%"
                                                single-line
                                                hide-details
                                            ></v-text-field>
                                            <v-btn
                                                @click="search = ''"
                                                small
                                                text
                                                color="primary"
                                                class="ml-2 mb-2"
                                                style="padding: 6px"
                                            >
                                                Clean
                                            </v-btn>
                                        </div>
                                    </v-menu>
                                </template>

                                <template v-slot:item="{ item }">
                                    <tr>
                                        <td
                                            column="lp"
                                            class="fixCol_first"
                                            style="
                                                text-wrap: nowrap;
                                                max-width: 120px;
                                                white-space: nowrap;
                                                overflow: hidden;
                                                text-overflow: ellipsis;
                                            "
                                        >
                                            {{ item.LP.toUpperCase() }}
                                        </td>
                                        <td
                                            column="Symbol"
                                            style="
                                                text-wrap: nowrap;
                                                max-width: 100px;
                                                white-space: nowrap;
                                                overflow: hidden;
                                                text-overflow: ellipsis;
                                            "
                                        >
                                            {{ item.Symbol }}
                                        </td>
                                        <td column="Position" align="right">
                                            {{
                                                item.Position === "N/A"
                                                    ? item.Position
                                                    : numberWithCommas(
                                                          parseFloat(
                                                              item.Position
                                                          )
                                                      )
                                            }}
                                        </td>
                                        <td column="Margin_Rate" align="right">
                                            {{
                                                item["Margin Rate"] === "N/A"
                                                    ? item["Margin Rate"]
                                                    : parseInt(
                                                          item["Margin Rate"] *
                                                              100
                                                      ) + "%"
                                            }}
                                        </td>
                                        <td
                                            column="Detail"
                                            class="fixCol_last"
                                            align="right"
                                            style="
                                                padding: 0 8px  !important;
                                            "
                                        >
                                            <v-icon
                                                small
                                                style="color: #2196f3"
                                                @click="
                                                    dialogShow = true;
                                                    dialogType = 'position';
                                                    dialogItem = item;
                                                "
                                                >mdi-eye</v-icon
                                            >
                                        </td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
        <LpDetailDialog
            :dialogShow="dialogShow"
            @close="dialogShow = false"
            :dialogType="dialogType"
            :dialogItem="dialogItem"
        />
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { permission } from "@components/mixins/permission";
import { helper } from "@components/mixins/helper";
import { snackbar } from "@components/mixins/snackbar";
import common from "@assets/js/common";
import LpDetailDialog from "./component/LpDetailDialog.vue";

export default {
    mixins: [permission, helper, snackbar],
    components: { LpDetailDialog },
    data() {
        return {
            search: "",
            selectedLp: "ALL",
            selectedLpId: -1,
            loadTable: false,
            timeOffset: 1000 * 60,
            selectedSymbols: [],
            positionTimer: 0,
            accountTimer: 0,
            timerOption: [
                { name: "off", value: 0 },
                { name: "15s", value: 15 },
                { name: "30s", value: 30 },
            ],
            positionTimeInterval: null,
            accountTimeInterval: null,
            positionTimerValue: 0,
            accountTimerValue: 0,
            hardRefresh: null,
            dialogShow: false,
            dialogType: undefined,
            dialogItem: undefined,
        };
    },
    watch: {
        /**
         * Watch on lplist change
         * @param   {[type]}  nv  [nv description]
         * @return  {[type]}      [return description]
         */
        lpList(nv) {
            // assign the initial value to selected value
            if (nv.length !== 0 && this.selectedLp === "ALL") {
                this.selectedLp = nv[0].lp_name;
                this.selectedLpId = nv[0].id;
                this.getLPAccountAction();
                this.getLPPositionAction();
            }
        },
        /**
         * Change selected lp value
         * @param   {[type]}  nv  [nv description]
         * @return  {[type]}      [return description]
         */
        selectedLpId(nv) {
            this.UPDATE_BATCH_ADD_LP_ID(nv);
        },
        positionTimer(nv) {
            if (nv == 0) {
                clearInterval(this.positionTimeInterval);
            } else {
                clearInterval(this.positionTimeInterval);
                this.positionTimerValue = 0;
                this.positionTimeInterval = setInterval(() => {
                    if (this.positionTimerValue >= 100) {
                        this.positionTimerValue -= 100;
                        this.getLPPositionAction();
                    } else {
                        this.positionTimerValue += 10 / this.positionTimer;
                    }
                }, 100);
            }
        },
        accountTimer(nv) {
            if (nv == 0) {
                clearInterval(this.accountTimeInterval);
            } else {
                clearInterval(this.accountTimeInterval);
                this.accountTimerValue = 0;
                this.accountTimeInterval = setInterval(() => {
                    if (this.accountTimerValue >= 100) {
                        this.accountTimerValue -= 100;
                        this.getLPAccountAction();
                    } else {
                        this.accountTimerValue += 10 / this.accountTimer;
                    }
                }, 100);
            }
        },
    },
    computed: {
        ...mapState("LP", [
            "accountHeader",
            "accountMobileHeader",
            "accountData",
            "positionHeader",
            "positionMobileHeader",
            "positionData",
            "lpList",
            "accountLoading",
            "positionLoading",
        ]),

        isWorkingDay() {
            return common.isWeekday();
        },
        activeLP() {
            let result = [];
            this.lpList.map((item) => {
                if (item.active === 1) {
                    result.push(item.lp_name.toUpperCase());
                }
            });

            return result;
        },
        filteredAccountData() {
            let result = [];
            this.accountData.map((item) => {
                if (
                    this.activeLP.includes(item.LP.split("_")[0].toUpperCase())
                ) {
                    result.push(item);
                }
            });
            return result;
        },
        /**
         * Return selected lp position data
         * @return  {[type]}  [return description]
         */
        lpPositionData() {
            if (this.selectedLp === "ALL") {
                return this.positionData.filter(
                    (item) =>
                        this.activeLP.includes(item.LP.toUpperCase()) &&
                        item.Symbol.toUpperCase().match(
                            this.search.toUpperCase()
                        )
                );
            } else {
                return this.positionData.filter(
                    (item) =>
                        item.LP === this.selectedLp &&
                        item.Symbol.toUpperCase().match(
                            this.search.toUpperCase()
                        )
                );
            }
        },
    },
    methods: {
        ...mapActions("LP", [
            "getLPAccountAction",
            "getLPPositionAction",
            "getLPInfoAction",
        ]),
        ...mapMutations("LP", ["UPDATE_BATCH_ADD_LP_ID"]),
        /**
         * Refresh Account Data
         * @return  {[type]}  [return description]
         */
        refreshAccount() {
            this.getLPAccountAction();
        },
        refreshPosition() {
            this.getLPPositionAction();
        },
        /**
         * Change lp
         * @return  {[type]}  [return description]
         */
        changeLp(data) {
            this.selectedLp = data.lp_name;
            this.selectedLpId = data.id;
        },
        /**
         * Check lp last update time is out of date or not
         * Threshold seconds is 60s
         * @param   {[type]}  time  [time description]
         * @return  {[type]}        [return description]
         */
        isOutsideOfTimeOffset(time) {
            if (
                Math.abs(
                    new Date(common.getMT4TimeString()).getTime() -
                        new Date(time).getTime()
                ) < this.timeOffset
            )
                return false;
            return true;
        },
        /**
         * batch add symbol
         */
        handleAddSymbol() {
            this.$emit(
                "addSymbol",
                this.selectedSymbols.map((item) => item.Symbol)
            );
        },
        changeTimer(timeInterval, section) {
            if (section == "position") {
                this.positionTimer = timeInterval;
            } else if (section == "account") {
                this.accountTimer = timeInterval;
            }
        },
        onSearch(field) {
            setTimeout(() => {
                this.$refs[field].focus();
            }, 200);
        },
    },
    created() {
        this.hardRefresh = setInterval(() => {
            this.refreshAccount();
        }, this.timeOffset * 2);
    },
    mounted() {
        let params = { active: 1 };
        this.getLPInfoAction(params);
    },
    beforeDestroy() {
        clearInterval(this.accountTimeInterval);
        clearInterval(this.positionTimeInterval);
        clearInterval(this.hardRefresh);
    },
};
</script>

<style>
.custom-table td {
    padding: 0 6px !important;
}

.custom-table th {
    padding: 0 6px !important;
}
.fixCol_last.header {
    z-index: 4 !important;
}
.fixCol_last {
    position: sticky !important;
    right: 0;
    z-index: 2 !important;
    background-color: #1e1e1e;
}
.v-card-title-left {
    margin-left: 0;
    width: 30%;
    font-size: 14px;
    font-weight: normal;
}
.v-card-title-right {
    margin-right: 0;
    width: 70%;
}
.custom-table .v-data-table__wrapper::-webkit-scrollbar {
  width: 0 !important;
}
</style>
